import Typography from '@mui/material/Typography';
import { PRODUCT_TUTORIALS } from 'common/constants';
import { InfoIcon } from 'components/Icons';
import InformationPaywall from 'components/InformationPaywall';
import { memo, useMemo } from 'react';
import { SpotDetails } from 'types/spot';

import styles from './YesterdayPill.module.scss';

const YesterdayPill = ({
  spot,
  formattedRewindDisplayDay,
}: {
  formattedRewindDisplayDay: string;
  spot?: SpotDetails;
}) => {
  const segmentProps = useMemo(
    () => ({
      modalType: 'yesterday-camera',
      spotId: spot?._id,
      spotName: spot?.name,
      subregionId: spot?.subregion?._id,
      subregionName: spot?.subregion?.name,
      uiElement: 'camera',
      location: 'yesterday-camera',
    }),
    [spot],
  );
  return (
    <InformationPaywall
      articleId={PRODUCT_TUTORIALS.articles.camRewindPaywalls.id}
      segmentProps={segmentProps}
      className={styles.informationWrapper}
    >
      <div className={styles.camPaywallYesterdayPill}>
        <Typography
          className={styles.camPaywallYesterdayPillText}
          data-testid="cam-paywall-yesterday-pill"
          variant="overline3"
        >
          {formattedRewindDisplayDay}
        </Typography>
        <InfoIcon />
      </div>
    </InformationPaywall>
  );
};

export default memo(YesterdayPill);
